import React, { Component } from 'react';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        const { onError } = this.props;
        onError(error, errorInfo);
    }
    render() {
        const { hasError } = this.state;
        const { children } = this.props;
        if (hasError) {
            return React.createElement(this.props.ErrorFallback, null);
        }
        return children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map